import { combineReducers } from "redux";
import { takeLatest } from "redux-saga/effects";
import { ToastError } from "components/Global/Toasts/Toasty";
import {
  defaultReturn
  , makePayload
  , generateDefaultActions
  , requestSaga
  , makeIsLoadingReducer
} from "shared-utility/store/utils/helpers";

// ACTIONS
export const PROPERTY_GET_BY_DEAL = generateDefaultActions("PROPERTY_GET_BY_DEAL");
export const propertyGetByDeal = payload => makePayload(PROPERTY_GET_BY_DEAL.value, payload);
function* propertyGetByDealSaga(payload) {
  const url = `/properties/deal/${payload.dealId}`;
  yield requestSaga(PROPERTY_GET_BY_DEAL, url, "GET");
}

export const PROPERTY_GET_DEAL_METRICS = generateDefaultActions("PROPERTY_GET_DEAL_METRICS");
export const propertyGetDealMetrics = payload => makePayload(PROPERTY_GET_DEAL_METRICS.value, payload);
function* propertyGetDealMetricsSaga(payload) {
  const url = `/deals/${payload.dealId}/metrics`;
  yield requestSaga(PROPERTY_GET_DEAL_METRICS, url, "GET");
}

export const PROPERTY_GET_DEAL = generateDefaultActions("PROPERTY_GET_DEAL");
export const propertyGetDeal = payload => makePayload(PROPERTY_GET_DEAL.value, payload);
function* propertyGetDealSaga(payload) {
  const url = `/getDealName/${payload.dealId}`;
  yield requestSaga(PROPERTY_GET_DEAL, url, "GET");
}

// REDUCER

const initialState = {
  properties: [],
  dealMetrics: [],
  deal: {}
};

function propertyModuleReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case PROPERTY_GET_BY_DEAL.success:
      return defaultReturn(state, payload.data, "properties");

    case PROPERTY_GET_DEAL_METRICS.success:
      return defaultReturn(state, payload.data.dealMetrics, "dealMetrics");

    case PROPERTY_GET_DEAL.success:
      return defaultReturn(state, payload.data, "deal");

    case PROPERTY_GET_BY_DEAL.error:
      ToastError("Data Fetch Unsuccessful");

      return defaultReturn(state);

    default:
      return state;
  }
}

export default combineReducers({
  propertyModuleReducer,
  propertyByDealLoading: makeIsLoadingReducer(PROPERTY_GET_BY_DEAL)
});

// SAGA

export function* propertyModuleSaga() {
  yield takeLatest(PROPERTY_GET_BY_DEAL.value, propertyGetByDealSaga);
  yield takeLatest(PROPERTY_GET_DEAL.value, propertyGetDealSaga);
  yield takeLatest(PROPERTY_GET_DEAL_METRICS.value, propertyGetDealMetricsSaga);
}
